import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export default function StripeConnectSection({
  title,
  description,
  children,
  showHeader = true,
  showCardShell = true,
}) {
  const header = showHeader ? (
    showCardShell ? (
      <CardHeader className="pb-0">
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
    ) : (
      <div className="space-y-1">
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </div>
    )
  ) : null

  const content = showCardShell ? (
    <CardContent>
      <div className="rounded-md">{children}</div>
    </CardContent>
  ) : (
    <div>{children}</div>
  )

  if (!showCardShell) {
    if (!header) {
      return content
    }

    return (
      <div className="space-y-6">
        {header}
        {content}
      </div>
    )
  }

  return (
    <Card>
      {header}
      {content}
    </Card>
  )
}
